/**
 * Simple TTL cache for catalog data.
 *
 * Avoids re-fetching catalog on every hook mount when multiple components
 * use usePricing() on the same page. Catalog is server-cached for 60s
 * (Cache-Control), so a matching client TTL is appropriate.
 */
export class TtlCache {
    ttlMs;
    store = new Map();
    constructor(ttlMs) {
        this.ttlMs = ttlMs;
    }
    get(key) {
        const entry = this.store.get(key);
        if (!entry)
            return undefined;
        if (Date.now() > entry.expiresAt) {
            this.store.delete(key);
            return undefined;
        }
        return entry.value;
    }
    set(key, value) {
        this.store.set(key, {
            value,
            expiresAt: Date.now() + this.ttlMs,
        });
    }
    invalidate(key) {
        this.store.delete(key);
    }
    clear() {
        this.store.clear();
    }
}
